// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AssetHash} from './asset-hash.js'
import {PDFFieldValueType} from './pdffield-value-type.js'

export class ModifyPDFField {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyPDFField {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyPDFField(bb: flatbuffers.ByteBuffer, obj?: ModifyPDFField): ModifyPDFField {
    return (obj || new ModifyPDFField()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyPDFField(bb: flatbuffers.ByteBuffer, obj?: ModifyPDFField): ModifyPDFField {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyPDFField()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  assetHash(obj?: AssetHash): AssetHash | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new AssetHash()).__init(this.bb_pos + offset, this.bb!) : null
  }

  key(): string | null
  key(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  key(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  valueType(): PDFFieldValueType {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : PDFFieldValueType.String
  }

  valueString(): string | null
  valueString(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  valueString(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  valueBoolean(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startModifyPDFField(builder: flatbuffers.Builder) {
    builder.startObject(5)
  }

  static addAssetHash(builder: flatbuffers.Builder, assetHashOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, assetHashOffset, 0)
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, keyOffset, 0)
  }

  static addValueType(builder: flatbuffers.Builder, valueType: PDFFieldValueType) {
    builder.addFieldInt8(2, valueType, PDFFieldValueType.String)
  }

  static addValueString(builder: flatbuffers.Builder, valueStringOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, valueStringOffset, 0)
  }

  static addValueBoolean(builder: flatbuffers.Builder, valueBoolean: boolean) {
    builder.addFieldInt8(4, +valueBoolean, null)
  }

  static endModifyPDFField(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // asset_hash
    builder.requiredField(offset, 6) // key
    return offset
  }

  static createModifyPDFField(
    builder: flatbuffers.Builder,
    assetHashOffset: flatbuffers.Offset,
    keyOffset: flatbuffers.Offset,
    valueType: PDFFieldValueType,
    valueStringOffset: flatbuffers.Offset,
    valueBoolean: boolean | null
  ): flatbuffers.Offset {
    ModifyPDFField.startModifyPDFField(builder)
    ModifyPDFField.addAssetHash(builder, assetHashOffset)
    ModifyPDFField.addKey(builder, keyOffset)
    ModifyPDFField.addValueType(builder, valueType)
    ModifyPDFField.addValueString(builder, valueStringOffset)
    if (valueBoolean !== null) ModifyPDFField.addValueBoolean(builder, valueBoolean)
    return ModifyPDFField.endModifyPDFField(builder)
  }
}
